module.exports = __webpack_public_path__ + "img/img_safety_img2.8fe1531e.png";